// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiEndpoint: 'https://prod-welldb-api-as.azurewebsites.net/welldb/v1/api',
  loginUrl : '/auth/login/',
  dccUrl : '/dcc',
  loadDccUrl : '/dcc/draft',
  validateDcc : '/dcc/validate',
  resetPasswordUrl : '/auth/reset_password',
  forgotPasswordUrl : '/auth/forgot_password',
  updatePasswordUrl : '/auth/update_password',
  changePasswordUrl : '/auth/change_password',
  dossierUrl : '/dossiers',
  createDossier : '/dossiers/fe/create',
  updateDssier : '/dossiers/update',
  uploadFiles : '/dossiers/uploadfiles',
  downloadFile : '/dossiers/downloadfile',
  deleteFile : '/dossiers/deletefile',
  uploadCVFiles : '/dossiers/uploadCVfiles',
  downloadCVFile : '/dossiers/downloadCVfile',
  deleteCVFile : '/dossiers/deleteCVfile',
  searchSimpleUrl : '/search/simple',
  searchAvanceUrl : '/search/advanced',
  searchUsersUrl : '/search/users',
  generatePDFUrl : '/dossiers/generatePDF',
  getFileConsultantConnected:'/auth/getFileConsultantConnected',  

  //Ajouter ou supprimer un dossier des favorites
  addDossierFavorite : '/dossiers/addFavorite',
  removeDossierFavorite : '/dossiers/removeFavorite',
  removeAllFavorisManager: '/dossiers/removeAllFavorisManager',

  uploadFileBilanAnnuel: '/dossiers/uploadFileBilanAnnuel',
  deleteFileBilanAnnuel: '/dossiers/deleteFileBilanAnnuel',
  

  statsTotalDossier : '/stats/dossiers',
  statsTotalCandidats : '/stats/candidats',
  statsTotalConsultants : '/stats/consultants',
  statsTotalManagers : '/stats/managers',
  statsTotalCandiNonValid : '/stats/candiNonValide',
  statsTotalEntretien : '/stats/totalEntretien',
  statsTotalEntretienParManager : '/stats/totalEntretienParManger',
  statsgetTotalseenMoreThanOnce : '/stats/getTotalseenMoreThanOnce',
  statsgetConsultantByManager : '/stats/getConsultantByManager',
  statsgetnameConsultantByManager : '/stats/nameConsultantByManager',
  statsgetInterviewsBetweenTwodates: '/stats/interviewsBetweenTwodates',
  statsgetInfoConsultants: '/stats/getInfoConsultants',
  statsgetInfoAnciensConsultants: '/stats/getInfoAnciensConsultants',
  statsgetAllMyFolderFavorite: '/stats/getAllMyFolderFavorite',
  statsgetAllFolderFavorite: '/stats/getAllFolderFavorite',
  statsgetMyCooptations: '/stats/getMyCooptations',
  statsgetStatOriginRecuitment: '/stats/getStatOriginRecuitment',
  statsgetStatRecuitmentcurrentYear: '/stats/getStatRecuitmentcurrentYear',
  statsgetStatRecuitmentanneeMoinUn: '/stats/getStatRecuitmentanneeMoinUn',
  statsgetStatRecuitmentanneeMoinDeux: '/stats/getStatRecuitmentanneeMoinDeux',
  statsgetStatRecuitmentanneeMoinTrois: '/stats/getStatRecuitmentanneeMoinTrois',
  statsgetStatRecuitmentanneeMoinQuatre: '/stats/getStatRecuitmentanneeMoinQuatre',
  statsgetStatRecuitmentParDate:'/stats/getStatRecuitmentParDate',



  
  
  userUrl : '/users',
  addUser: '/auth/register',
  currentUser: '/auth/profile',
  updateCurrentUser: '/users/currentUser',
  archiveAccountUser: '/users/archiveAccount', 
  reactivateAccountUser: '/users/reactivateAccount', 
  shareCandidateFile: '/auth/shareFolder', 
  sendWorkCertificate: '/auth/sendAttestation',



  contentTypes : {
    json : 'application/json; charset=utf-8',
    XwwwFormUrlencoded : 'application/x-www-form-urlencoded; charset=utf-8'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts